import { render, staticRenderFns } from "./LiveStageToggle.vue?vue&type=template&id=4803f74c&scoped=true"
import script from "./LiveStageToggle.vue?vue&type=script&lang=js"
export * from "./LiveStageToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4803f74c",
  null
  
)

export default component.exports